import { useEffect, useState } from "react";
import { getVisitDepartmentByDate } from "../services/VisitDepartmentApi";

export const useVisitDepartment = () => {
  const [visitDepartmentName, setVisitDepartmentName] = useState();

  const fetchVisitDepartmentByDate = async (data) => {
    try {
      const res = await getVisitDepartmentByDate(data);
      if (res.status === true) {
        setVisitDepartmentName(res.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchVisitDepartmentByDate();
  }, []);

  return { visitDepartmentName, fetchVisitDepartmentByDate };
};
